import React, { useState, useEffect, useContext } from "react";
import { GoClock } from "react-icons/go";
import { IoCheckmark } from "react-icons/io5";
import './rightDetails.scss';
import { CgClose } from "react-icons/cg";
import { use } from "react";
import candidateApi from "../../services/candidateApi";
import { toast } from "react-toastify";
export const CandidateActivity = ({activities= [], candidateId}) => {

  const [candidateActivities, setCandidateActivities] = useState([]);


  useEffect(() => {
      if (candidateId) {
       fetchCandidateDetails(candidateId);
      }
  }, [activities]);

  const fetchCandidateDetails = async (id) => {
    try {
      const response = await candidateApi.getCandidateById(id);
      console.log(activities)
      if (response?.data) {
        setCandidateActivities([...activities,
            {activityDate: response.data.createdAt, actionTaken: "Created", outcome: "New", userName: response.data.createdBy}]);
      }
    } catch (error) {
      console.error("Error fetching candidate details:", error);
      toast.error("Error fetching candidate details", {
        position: "top-right",
        autoClose: 2000,
      });
    }
  }



  return (
    <section className="activity-wrapper candidate-activity">
      {candidateActivities?.map((activity, index) => (
        <div className="activity-holder d-flex gap-3 position-relative completed">
        {/* <div className="dateInfo">
          <span>  <GoClock /> </span>
          {activity?.activityDate ? new Date(activity?.activityDate).toLocaleDateString('en-GB') : 'N/A'} <br />
          <div className="text-center">{activity?.activityDate ? new Date(activity?.activityDate).toLocaleTimeString('en-GB') : 'N/A'}</div>
        </div> */}
        <div className="dateInfo">
          <span><GoClock /></span>
          {activity?.activityDate 
            ? new Date(activity.activityDate).toLocaleDateString('en-GB') 
            : 'N/A'}  <br />
          <div className="text-center">
          {activity?.activityDate 
              ? activity.activityDate.substring(11, 19) // Gets "HH:MM:SS" part
              : 'N/A'}
          </div>
        </div>



        <span className={activity.outcome === "Rejected" ? "icon bg-danger border-danger" : "icon"}>
          {activity.outcome === "Rejected" ? <CgClose/> : <IoCheckmark />}
        </span>
        <div className="activity-info">
          <h6>{activity?.actionTaken + ' - '+ activity?.outcome}</h6>
          <p className="mb-0"><span>Action Taken by :</span> {activity?.userName} {activity?.userName && ", "} {activity?.createdUsers}</p>
          {/*<p className="mb-0"><span>Action Taken :</span>  Slected to Next Level</p>*/}
        </div>
      </div>
      ))}
      {/* activity repeat start here }
      <div className="activity-holder d-flex gap-3 position-relative">
        <div className="dateInfo">
          <span>  <GoClock /> </span>
          20 Dec 2024
        </div>
        <span className="icon">
          <IoCheckmark />
        </span>
        <div className="activity-info">
          <h6>Interview - Technical</h6>
          <p className="mb-0"><span>Assigned to :</span>  Sijith C & Sony</p>
        </div>
      </div>
      {/* activity repeat ends here */}
       {/* activity repeat start here }
       <div className="activity-holder d-flex gap-3 position-relative completed">
        <div className="dateInfo">
          <span>  <GoClock /> </span>
          20 Dec 2024
        </div>
        <span className="icon">
          <IoCheckmark />
        </span>
        <div className="activity-info">
          <h6>Interview - HR</h6>
          <p className="mb-0"><span>Action Taken by :</span>  Rebecca</p>
          <p className="mb-0"><span>Action Taken :</span>  Slected to Next Level</p>
        </div>
      </div>
      {/* activity repeat ends here */}
       {/* activity repeat start here }
       <div className="activity-holder d-flex gap-3 position-relative completed">
        <div className="dateInfo">
          <span>  <GoClock /> </span>
          20 Dec 2024
        </div>
        <span className="icon">
          <IoCheckmark />
        </span>
        <div className="activity-info">
          <h6>Profile Created</h6>
          <p className="mb-0"><span>Action Taken by :</span>  Rebecca</p>
        </div>
      </div>
      {/* activity repeat ends here */}

    </section>
  );
}

